export function mod(value, divide) {
    return ((value % divide) + divide) % divide;
}